import styled, { css } from 'styled-components'

import { Badge } from '@avantstay/backoffice-core'

import { IconInfo } from '@avantstay/backoffice-vectors'

export const Root = styled.div``

export const StyledBadge = styled(Badge)<{ hasPrefix?: boolean }>`
  ${({ hasPrefix }) =>
    hasPrefix &&
    css`
      margin-bottom: 4px;
      margin-right: 4px;
    `};

  gap: 4px;
`

export const StyledInfoIcon = styled(IconInfo)`
  width: 14px;
  height: 14px;
`
